import React, { useMemo } from 'react'
import PartnerWorkoutResourceForm from './_form'

export default function PartnerWorkoutResourceAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <PartnerWorkoutResourceForm data={data} {...props} />
  )
}